import { nodeInputRule, ReactNodeViewRenderer } from '@tiptap/react'
import { Plugin, PluginKey } from 'prosemirror-state'
import * as TImage from '@tiptap/extension-image'
import { ImageNode } from './image-node'

const IMAGE_INPUT_REGEX = /!\[(.+|:?)]\((\S+)(?:(?:\s+)["'](\S+)["'])?\)/

export const TTImage = TImage.Image.extend({
  name: 'image',
  draggable: true,
  group: 'block',

  // @ts-ignore
  addOptions() {
    return {
      uploadImage: (i: any) => {},
    }
  },

  addAttributes() {
    return {
      src: {
        default: null,
        parseHTML: (el) => (el as HTMLSpanElement).getAttribute('src'),
        renderHTML: (attrs) => ({ src: attrs.src }),
      },
      source_id: {
        default: null,
        parseHTML: (el) => (el as HTMLSpanElement).getAttribute('source_id'),
        renderHTML: (attrs) => ({ source_id: attrs['source_id'] }),
      },
    }
  },

  addInputRules() {
    return [
      nodeInputRule({
        find: IMAGE_INPUT_REGEX,
        type: this.type,
        getAttributes: (match) => {
          const [, , src] = match

          return { src }
        },
      }),
    ]
  },

  addProseMirrorPlugins() {
    // @ts-ignore
    const upload = this.options.uploadImage
    return [
      new Plugin({
        key: new PluginKey('imageDropPlugin'),
        props: {
          handleDOMEvents: {
            drop(view, event) {
              const {
                state: { schema, tr },
                dispatch,
              } = view

              const hasFiles =
                event.dataTransfer && event.dataTransfer.files && event.dataTransfer.files.length

              if (!hasFiles) {
                return false
              }

              const images = Array.from(event.dataTransfer.files).filter((file) =>
                /image/i.test(file.type),
              )

              if (images.length === 0) {
                return false
              }

              event.preventDefault()

              const coordinates = view.posAtCoords({ left: event.clientX, top: event.clientY })

              upload(images[0]).then((data) => {
                const { url, source_id } = data
                const image = new Image()
                image.src = url
                image.onload = (readerEvent) => {
                  const node = schema.nodes.image.create({ src: url, source_id }) // creates the image element
                  // @ts-ignore
                  if (coordinates && typeof coordinates.pos === 'number') {
                    const transaction = tr.insert(coordinates.pos, node) // places it in the correct position
                    dispatch(transaction)
                  }
                }
              })

              return true
            },
          },
        },
      }),
    ]
  },

  addNodeView() {
    return ReactNodeViewRenderer(ImageNode, {
      as: 'div',
      contentDOMElementTag: 'div',
      attrs: {
        ...this.options.HTMLAttributes,
      },
    })
  },
})
